export const PRIORITIZE_SECTIONS = [
  { key: 'no-due-date', label: 'Unprioritized' },
  { key: 'today', label: 'Today' },
  { key: 'work-in-progress', label: 'Work in progress' },
  { key: 'later', label: 'Later' },
  { key: 'done', label: 'Done' }
];
